var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from 'react-jss';
import useStyles from './styles';
import clsx from 'clsx';
const getTag = variant => {
    switch (variant) {
        case 'header1': return 'h1';
        case 'header2': return 'h2';
        case 'header3': return 'h3';
        case 'header4': return 'h4';
        default: return 'p';
    }
};
const Typography = (_a) => {
    var { children, variant = 'content1', weight = 'normal', color = null, italic = false, link = false, center = false, inheritColor = false, customClassName = '', inlineStyles = {}, nowrap = false } = _a, rest = __rest(_a, ["children", "variant", "weight", "color", "italic", "link", "center", "inheritColor", "customClassName", "inlineStyles", "nowrap"]);
    const theme = useTheme();
    const classes = useStyles({ theme });
    const typographyStyle = clsx({
        [classes.base]: true,
        [customClassName]: Boolean(customClassName),
        [classes[variant]]: true,
        [classes[color]]: Boolean(color),
        [classes[weight]]: true,
        [classes.italic]: italic,
        [classes.link]: link,
        [classes.inherit]: inheritColor,
        [classes.center]: center,
        [classes.nowrap]: nowrap
    });
    const Tag = link ? 'a' : getTag(variant);
    return (React.createElement(Tag, Object.assign({ className: typographyStyle, style: inlineStyles }, rest), children));
};
export { Typography };
//# sourceMappingURL=Typography.js.map